import moment from 'moment-timezone';

export const globalMixin = {
    computed: {
        roles() {
            return this.$store.state.loggedUser ? this.$store.state.loggedUser.user_roles : [];
        },
		isSuperOrAdminAccount(){
			return [1, 2].some(role => this.loggedUser?.roles.includes(role))
		},
        isCustomerAccount() {
            return [2, 3, 4, 5].some(role => this.loggedUser?.roles.includes(role));
        },
        isGuest() {
            return [10].some(role => this.loggedUser?.roles.includes(role));
        },
		validToken(){
			return this.loggedUser?.token_expiry > Date.now() / 1000;
		}
    },
    methods: {
		parseNumber(value) {
			return parseInt(value.toString().replace(/,/g, ''), 10);
		},
        formatDate(date) {
            return date ? moment.tz(date, 'YYYY-MM-DD hh:mm A', 'Asia/Manila').format('YYYY-MM-DD') : '';
        },
        formatDateTime(dateTime) {
            return dateTime ? moment(dateTime).tz('Asia/Manila').format('YYYY-MM-DD hh:mm A') : "";
        },
        formatDateToLong(date, time = false) {
            return date ? new Intl.DateTimeFormat('en-PH', { 
                month: 'long', 
                day: 'numeric', 
                year: 'numeric', 
                ...(time && { 
                    hour: 'numeric', 
                    minute: 'numeric', 
                    second: 'numeric', 
                    hour12: true 
                })
            }).format(date).replace(/ at /g, ' ') : '';
        },
        formatDecimal(data) {
            return parseFloat(data).toLocaleString('en-PH', 
                { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        },
        formatToMoney(data){
            return parseFloat(data).toLocaleString('en-PH', 
                { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        formatToCommaSeparated(data) {
            if (!data) return '';
            return data.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        formatIntegersOnly(event) {
			console.log('=======')
            const value = event.target.value.replace(/\D/g, '');
            return value;
        },
        formatNameDate(name, date) {
            const _name = name ? name.first_name + ' ' + name.last_name + ' - ': '';
            const _date = date ? moment(date).tz('Asia/Manila').format('YYYY-MM-DD hh:mm A') : "";
            return _name && _date ? _name + _date : '';
        },
        getLabel(list, key) {
            const type = list.find(item => item.key === key);
            return type ? type.value : 'None';
        },
        formatLabel(key){
            return key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase()) + ":";
        },
        canExportToPDF(order) {
            return order.client_order_status_id === 5;
        },
        canEdit(status) {
            return this.roles.some(role => [2, 3].includes(role.id)) && status === 1;
        },
        canCheck(status){
            return this.roles.some(role => [2, 4].includes(role.id)) && status === 1;
        },
        canUncheck(status){
            return this.roles.some(role => [2, 4].includes(role.id)) && status === 2;
        },
        canPreCheck(status){
            return this.roles.some(role => [2, 3].includes(role.id)) && status === 2;
        },
        canApproveOrCancel(status) {
            return this.roles.some(role => [2, 5].includes(role.id)) && status === 2; //can approve when status is checked(2)
        },
        canProceedOrCancel(order) {
            return this.roles.some(role => [2, 3].includes(role.id)) && 
            order.client_order_status_id === 5 && order.order_status_id === 1;
        },
        removePrefix(string) {
            return string.split('#')[1];
        },
		handleInputChange(field, event) {
            if (field.attrs?.allCaps) {
                return this.data[field.name] = event.target.value.toUpperCase();
            } else {
                if(field.name !== 'email'){
                    event.target.value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1).toLowerCase();
                }
                return this.data[field.name] = event.target.value;
            }
        },
    },
};